export default {
  banner: {
    slogan: {
      part1: 'Creating product, Igniting progress',
      part2: 'Unleashing energy, A future to exchange'
    }
  },
  accordion: {
    learnMore: "Learn More",
    items: {
      company: {
        title: "About Us",
        content:
          "Shanghai Superconductor is a high-tech enterprise focused on the research, development, production and sales of high-temperature superconducting materials. Shanghai Superconductor is committed to becoming a global leader in the superconducting field and has grown into one of the core suppliers of second-generation high-temperature superconducting materials worldwide.",
      },
      applications: {
        title: "Applications",
        content:
          "The company's core business covers high-temperature superconducting tapes (wires) and related technical services, with products widely used in cutting-edge technology fields such as controlled nuclear fusion, superconducting power, and high-field magnets.",
      },
      products: {
        title: "Products & Services",
        content:
          "The company's main product is second-generation high-temperature superconducting tapes (wires), which have broken through the upstream, midstream and downstream industrial chains, while providing customers with complete high-quality products. It is one of the international manufacturers capable of mass-producing and selling over 1,000 kilometers of high-temperature superconducting tapes (wires) annually.",
      },
      news: {
        title: "Company News",
        content: "Latest information on company news, industry trends, and technical developments.",
      },
      contact: {
        title: "Contact Us",
        content: "Contact us for more information.",
      },
    },
  },
  company: {
    items: {
      introduction: {
        title: "Company Profile",
        content: "",
      },
      dream: {
        title: "Vision & mission",
        content: "",
      },
      chronicle: {
        title: "Memorabilia",
        content: "",
      },
      partners: {
        title: "Partners",
        content: "",
      },
      honors: {
        title: "Honors & Qualifications",
        content: "",
      },
      structure: {
        title: "Subsidiary Organizations",
        content: "",
      },
    },
  },
  contactinfo: {
    title: "Contact Us",
    address: "Address: 781 Kangwei Road, Pudong New District, Shanghai",
    addressmobile: "781 Kangwei Road, Pudong New District, Shanghai",
    phone: "Phone: (Main) 021-50817399 (Sales) 021-64056173 (Recruitment) 021-50817399-8006",
    phonemobile1: "(Main) 021-50817399",
    phonemobile2: "(Sales) 021-64056173",
    phonemobile3: "(Recruitment) 021-50817399-8006",
    email: "Email: ",
    sales: "(Sales) sales{'@'}shsctec.com",
    hr: "(HR) hr{'@'}shsctec.com",
    inquiry: "(Inquiry) inquiry{'@'}shsctec.com",
    inspection: "(Anti-commercial bribery) inspection{'@'}shsctec.com",
    serviceAccount: "Service Account",
    subscriptionAccount: "Subscription Account"
  },
};
